import Style from './FJInput.module.less';
import passwordShowIcon from '../../../assets/icon/passwordShowIcon.svg';
import passwordHiddenIcon from '../../../assets/icon/passwordHiddenIcon.svg';
import InlineSVG from 'react-inlinesvg';
import React, { useImperativeHandle, useRef, useState } from 'react';
import FJLocalStore from '../../../store/FJLocalStore';
import classNames from 'classnames';
import FJUtil from '../../../../src/util/FJUtil';
import useLocalStore from '../../../hooks/useLocalStore';

let _isComposition = false;
const FJInput = React.forwardRef((props, ref) => {
    useLocalStore();
    let {
        value,
        valueChangeTime = 'onchange',
        label,
        placeholder,
        onChange,
        onInput,
        formatValue,
        type = 'text',
        hasRightIcon,
        style,
        forgetTip,
        forgetClick,
        className,
        inputClassName,
        iconClassName,
        maxInputLength,
        preventAutoComplete,
        popupType,
        // inputCanSee,
        // changeInputCanSee
        dataAutoId,
    } = props;

    const [inputType, setInputType] = useState(type);
    const [inputCanSee, setInputCanSee] = useState(false);
    const [inputErr, setInputErr] = useState(false);
    const [tipErr, setTipErr] = useState('');
    const _maxStringLength = useRef(maxInputLength || 50);
    // let _isComposition = useRef(false)
    // const [isComposition,setIsComposition]=useState(false)
    const inputRef = useRef();

    const [isReadOnly, setIsReadOnly] = useState(preventAutoComplete ? true : false);
    // const inputRef = useRef()
    useImperativeHandle(ref, () => {
        return {
            setErrorMessage: tip => {
                setInputErr(true);
                setTipErr(tip);
            },
            setInit: () => {
                setInputErr(false);
            },
        };
    });

    let changeIcon = () => {
        setInputCanSee(!inputCanSee);
        // changeInputCanSee(!inputCanSee)
        setInputType(!inputCanSee ? 'text' : type);
    };

    let _getValueLength = value => {
        return value.length;
    };
    let _setValue = value => {
        inputRef.current.value = value;
    };

    // 判断赋值在什么时候onInput/onChange进行改变，然后是否需要进行指定字符串操作
    let _onChange = e => {
        if (_isComposition === true) return;
        let curValue = e.target.value;
        if (valueChangeTime.toLowerCase() === 'onchange') {
            if (formatValue) {
                curValue = formatValue(curValue);
            }

            if (_getValueLength(curValue) > _maxStringLength.current) {
                curValue = curValue.slice(0, _maxStringLength.current);
            }
            curValue = FJUtil.filterStr(curValue);

            _setValue(curValue);
        }

        onChange && onChange(curValue, e);
    };

    let _onInput = e => {
        let curValue = e.target.value;
        if (valueChangeTime.toLowerCase() === 'oninput') {
            if (formatValue) {
                curValue = formatValue(curValue);
            }

            if (_getValueLength(curValue) > _maxStringLength.current) {
                curValue = curValue.slice(0, _maxStringLength.current);
            }

            curValue = FJUtil.filterStr(curValue);

            _setValue(curValue);
        }

        onInput && onInput(curValue, e);
    };

    let _onPaste = e => {
        let inputItem = inputRef.current;
        if (inputItem.offsetWidth < inputItem.scrollWidth) {
            inputItem.scrollTo({
                left: inputItem.scrollWidth - inputItem.offsetWidth + 10,
            });
        }
    };
    let _handleComposition = e => {
        if (e.type === 'compositionend') {
            _isComposition = false;
            _onChange(e);
        } else {
            _isComposition = true;
        }
    };

    let _keydownBack = event => {
        if ((event.metaKey || event.ctrlKey) && event.keyCode === 65) {
            inputRef.current.select();
        }
    };

    let _onFocus = () => {
        // preventAutoComplete
        FJUtil.addEvent(window, 'keydown', _keydownBack);
        setIsReadOnly(false);
    };
    let _onBlur = () => {
        FJUtil.removeEvent(window, 'keydown', _keydownBack);
        if (preventAutoComplete) {
            setIsReadOnly(true);
        }
    };
    return (
        <div className={classNames(Style.input_box, className, { [Style.input_box_small]: popupType })} style={style}>
            <div className={Style.input_header}>
                <div className={Style.label}>{label}</div>
                {forgetTip && (
                    <div className={Style.forget} onClick={forgetClick}>
                        {FJLocalStore._('forget-password?')}
                    </div>
                )}
            </div>
            <div className={classNames(Style.input_content)}>
                <input
                    className={classNames(Style.input, inputClassName, { [Style.input_err]: inputErr })}
                    type={inputType}
                    defaultValue={value}
                    placeholder={placeholder}
                    ref={inputRef}
                    readOnly={isReadOnly}
                    // autoComplete={preventAutoComplete ? 'new-password' : 'on'}
                    onFocus={_onFocus}
                    onBlur={_onBlur}
                    // onKeyDown={_onKeyDown}
                    onChange={_onChange}
                    onInput={_onInput}
                    onPaste={_onPaste}
                    // onMouseEnter={_onMouseEnter}
                    // onMouseUp={_onMouseUp}
                    // onMouseLeave={_onMouseLeave}
                    onCompositionStart={_handleComposition}
                    onCompositionEnd={_handleComposition}
                    data-auto-id={dataAutoId}
                />
                {hasRightIcon && (
                    <div className={classNames(Style.right_icon, iconClassName)} onClick={changeIcon}>
                        {inputCanSee ? <InlineSVG src={passwordShowIcon} /> : <InlineSVG src={passwordHiddenIcon} />}
                    </div>
                )}
                {inputErr ? <p className={Style.err_tip}>{tipErr}</p> : <p className={Style.err_tip_null} />}
            </div>
        </div>
    );
});
export default FJInput;
